import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ListItem } from "../../molecules";
import './StatusTabs.scss';
import { ElementLoader } from '../../atoms';

const LoaderEl = () => <ElementLoader />

function StatusTabs() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate()
  const handleClick = (tokenAddress,listType) => {
    navigate(`/${listType}/${tokenAddress}`);
  }
  const [paramStatus, setParamStatus] = useState('UPCOMING')
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState([])
  const getListData = async () => {
    try {
      setIsLoading(true)
      const response = await axios(`${apiUrl}/list/status?type=${paramStatus}`);
      if (response.status) {
        setData(response.data.data);
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log(error)
    }
  }
  const setStatus = (type) => {
    setParamStatus(type)
  }
  useEffect(() => {
    getListData()
  }, [paramStatus])

  return (
    <section className="statustabs">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <ul className="nav nav-tabs d-flex justify-content-center" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button onClick={() => setStatus('UPCOMING')} className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">Upcoming</button>
              </li>
              <li className="nav-item" role="presentation">
                <button onClick={() => setStatus('ONGOING')} className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Ongoing</button>
              </li>
              <li className="nav-item" role="presentation">
                <button onClick={() => setStatus('PAST')} className="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">Past</button>
              </li>
            </ul>
            {
              isLoading ? <LoaderEl /> : (
                <div className="tab-content" id="myTabContent">
                  {

                    data ? (
                      <>
                        <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                          {
                            data.map(item => {
                              return <ListItem key={item._id} status={item.status} title={item.status} detail={item} onClick={()=>handleClick(item.tokenAddress,item.listType)} />
                            })
                          }
                        </div>
                        <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                          {
                            data.map(item => {
                              return <ListItem key={item._id} status={item.status} title={item.status} detail={item} onClick={()=>handleClick(item.tokenAddress,item.listType)} />
                            })
                          }
                        </div>
                        <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                          {
                            data.map(item => {
                              return <ListItem key={item._id} status={item.status} title={item.status} detail={item} onClick={()=>handleClick(item.tokenAddress,item.listType)} />
                            })
                          }
                        </div>
                      </>
                    ) : (
                      <p className='text-white'>Data Not Found</p>
                    )
                  }
                </div>
              )
            }
          </div>
        </div>
      </div>
    </section>
  )
}

export default StatusTabs
